import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./Services/store";
const log = console.log;
console.log = function (...params) {
  if (process.env.NODE_ENV == "development") {
    log(...params);
  }
};
const error = console.error;
console.error = function (...params) {
  if (process.env.NODE_ENV == "development") {
    error(...params);
  }
};
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <App />
  </Provider>
  // </React.StrictMode>
);
